export enum BinEventTypes {
    BinsUpdated = "bins_updated"
}
